import { connect } from "react-redux";
import { NewUserForm } from "./NewUserForm";
import { createUser, fetchAllUsers } from "../../../../../redux/actions/user_actions";
import { storeProfileImage } from "../../../../../redux/actions/user_actions";


const mapStateToProps = (state) => {
    return ({
        users: state.users,
        currentUser: state.session.user,
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        createUser: (user) => dispatch(createUser(user)),
        fetchAllUsers: (cancelToken) => dispatch(fetchAllUsers(cancelToken)),
        storeProfileImage: (userId, profileImage) => dispatch(storeProfileImage(userId, profileImage))
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(NewUserForm);